import useBreakpointIndex from './useBreakpointIndex.js';
import 'react';
import '@emotion/react';

function useResponsiveValue(values, options) {
  if (options === void 0) {
    options = {};
  }
  const array = Array.isArray(values) ? values : [values];
  const index = useBreakpointIndex(options);
  return array[index >= array.length ? array.length - 1 : index];
}

export { useResponsiveValue as default };
